import React from 'react';
import './Icon.scss';

interface IconProps {
  category: string;
  size?: IconSize;
  ariaLabel?: string;
}

export type IconSize = IconSizes.SMALL | IconSizes.MEDIUM | IconSizes.LARGE;

export enum IconSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

const Icon: React.FC<IconProps> = ({ category, size = IconSizes.MEDIUM, ariaLabel}) => {
  return <div className={"icon " + size} aria-label={ariaLabel} title={ariaLabel}>
    <span className={'fa ' + category}></span>
  </div>;
};

export default Icon;
